import React from "react";
import { Col, Card, Row } from "antd";
import {
  KPITitleText,
  KpiSubText,
} from "../../../../../../shared/globalStyling/styledText";
import {
  formatWholeNumber,
  formatNumber,
} from "../../../../../../../core/utils/campaigns";
import { ExtraInfo } from "../../attribution/components";

const styles = {
  container: {
    backgroundColor: "#fff",
    borderTop: "solid 1px #e8e8e8",
    marginBottom: "1%",
  },
  secondaryContainer: {
    padding: "3% 3% 1% 3%",
    margin: 0,
  },
  title: {
    marginBottom: "10px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  keyColors: {
    spent: "#1665d8",
    remaining: "#34aa44",
    budget: "#030303",
    total: "#bec0c3",
    value: "#99999",
  },
};

const DetailsBar = ({
  data,
  aggregatedData,
  hasSimplifiedReport,
  basketItemsTable,
  basketItemsTableLoading,
}) => {
  let transactions = aggregatedData ? Object.keys(aggregatedData).length : 0;
  let revenue = 0;
  let quantity = 0;

  if (hasSimplifiedReport === false) {
    data.forEach(item => {
      revenue += parseFloat(item.PRICE) * parseInt(item.QUANTITY);
      quantity += parseInt(item.QUANTITY);
    });
  } else {
    transactions = basketItemsTable && parseInt(basketItemsTable.count);
    revenue = basketItemsTable && parseFloat(basketItemsTable.subTotal);
    quantity = basketItemsTable && parseInt(basketItemsTable.quantity);
  }

  return (
    <Row>
      <Col flex={4}>
        <Card
          loading={basketItemsTableLoading}
          style={{ height: "10em", borderLeft: 0, borderTop: 0 }}
          bodyStyle={{ borderLeft: 0, borderRight: 0 }}
        >
          <div style={styles.title}>
            <KPITitleText text={"Transactions"} />
          </div>
          <KpiSubText
            text={`${transactions ? formatWholeNumber(transactions) : 0}`}
          />
        </Card>
      </Col>
      <Col flex={4}>
        <Card
          loading={basketItemsTableLoading}
          style={{ height: "10em", borderLeft: 0, borderTop: 0 }}
          bodyStyle={{ borderLeft: 0 }}
        >
          <div style={styles.title}>
            <KPITitleText text={"Sub Total"} />
            <span>
              <ExtraInfo
                title={"Revenue before taxes, shipping and promotions"}
                placement={"top"}
              />
            </span>
          </div>
          <KpiSubText text={`$${formatNumber(revenue)}`} />
        </Card>
      </Col>
      <Col flex={4}>
        <Card
          loading={basketItemsTableLoading}
          style={{ height: "10em", borderLeft: 0, borderTop: 0 }}
          bodyStyle={{ borderLeft: 0 }}
        >
          <div style={styles.title}>
            <KPITitleText text={"Quantity"} />
            <span>
              <ExtraInfo
                title={
                  "Total number of product items within all selected transactions"
                }
                placement={"top"}
              />
            </span>
          </div>
          <KpiSubText text={`${formatWholeNumber(quantity)}`} />
        </Card>
      </Col>
    </Row>
  );
};

export default DetailsBar;
